import { render, staticRenderFns } from "./ServiceEventView.vue?vue&type=template&id=60f77b90"
import script from "./ServiceEventView.vue?vue&type=script&lang=js"
export * from "./ServiceEventView.vue?vue&type=script&lang=js"
import style0 from "./ServiceEventView.vue?vue&type=style&index=0&id=60f77b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports